import type { IEmployee } from '@/interfaces'

export class Employee implements IEmployee {
	id: number
	firstName: string
	lastName: string
	middleName: string
	displayName: string
	displayNameLastFirst: string
	displayNameLegacy: string
	active: boolean
	departmentId: string
	branchId: number
	jobTitle: string
	email: string
	manager: number
	salesTeam: number
	adpId: string
	preferredFirstName: string
	previousLastName: string
	b1userID: number
	b1userName: string
	constructor({
		id,
		firstName,
		lastName,
		middleName,
		displayName,
		displayNameLastFirst,
		displayNameLegacy,
		active,
		departmentId,
		branchId,
		jobTitle,
		email,
		manager,
		salesTeam,
		adpId,
		preferredFirstName,
		previousLastName,
		b1userID,
		b1userName
	}: IEmployee) {
		this.id = id
		this.firstName = firstName
		this.lastName = lastName
		this.middleName = middleName
		this.displayName = displayName
		this.displayNameLastFirst = displayNameLastFirst
		this.displayNameLegacy = displayNameLegacy
		this.active = active
		this.departmentId = departmentId
		this.branchId = branchId
		this.jobTitle = jobTitle
		this.email = email
		this.manager = manager
		this.salesTeam = salesTeam
		this.adpId = adpId
		this.preferredFirstName = preferredFirstName
		this.previousLastName = previousLastName
		this.b1userID = b1userID
		this.b1userName = b1userName
	}
}
